const ITEMS = [
    "DESK BOOKING",
    "FLOOR PLANS",
    "CAR LOGISTICS",
    "PEOPLE",
    "WORKFLOWS",
    "AI ASSISTANT",
    "AUDIT TRAIL",
];

function Row({ ariaHidden }) {
    return (
        <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
            {ITEMS.map((item) => (
                <span key={item + (ariaHidden ? "-b" : "-a")} className="flex items-center">
                    <span className="mono text-xs sm:text-sm tracking-[0.3em] text-[var(--ink-2)] px-6 sm:px-10 whitespace-nowrap">
                        {item}
                    </span>
                    <span className="w-1.5 h-1.5 rotate-45 bg-[var(--accent)]/60 shrink-0" />
                </span>
            ))}
        </div>
    );
}

export function Marquee() {
    return (
        <div
            data-testid="editorial-marquee"
            className="relative overflow-hidden bg-[#D4A93C]/[0.06] border-b border-[var(--line)] py-4 select-none"
        >
            <div className="marquee-track flex w-max">
                <Row ariaHidden={false} />
                <Row ariaHidden={true} />
            </div>
        </div>
    );
}
